import React from 'react';

export default function({ name }) {
  return <span className={`glyphicon glyphicon-${name}`} />
}



// WEBPACK FOOTER //
// ./src/components/Icon.js